import { PAGE_BOUNDED_ATTR, SHELL_LAYOUT_FLAT } from "./shell";
import { cn } from "@/lib/utils";
import { forwardRef, type ReactNode } from "react";

export const PageLayout = forwardRef<
  HTMLDivElement,
  {
    children: ReactNode;
    className?: string;
    // The page scrolls inside this layout; inside the shell the inset stops
    // scrolling the document for it.
    bounded?: boolean;
  }
>(({ children, className, bounded = false }, ref) => {
  return (
    <div
      ref={ref}
      {...(bounded ? { [PAGE_BOUNDED_ATTR]: "" } : {})}
      className={cn(
        "relative flex h-full w-full grow gap-2 overflow-hidden bg-surface-secondary p-2",
        className,
        // The shell is the frame; inside it the layout is only a flex row.
        SHELL_LAYOUT_FLAT
      )}
    >
      {children}
    </div>
  );
});

PageLayout.displayName = "PageLayout";
